/**
 * Конфигирурационный класс пользовательський событий
 *  Содержит в себе:
 *   static prefix -  префикс события
 *   static splitByPrefix -  метод для формирования имени события на основе конкатинирует prefix:eventName
 * Создание экземпляра класса запрещено.
 */


export class EventEmitterConfig {
    private constructor() {
    } // <-- запрет на создание экземпляра

    /**
     *  параметр (префикс событий)
     *  */
    static prefix = '_ispEvent'; //
    /**
     *  функция, использующая эту настройку для формирования имени события.
     * */
    static splitByPrefix(eventName: string): string {
        return `${EventEmitterConfig.prefix}:${eventName}`;
    }
}